export default class ProductHubDetails {
  lastSincronizedHubDate = false;
  synchronizedWithActiveHub = false;
  synchronizedWithHub = false;
}
